import { Component } from '@angular/core';
import { PrimeNGPopupViewComponent } from '@ntap/primeng';

@Component({
  selector: 'app-earhiv-popup',
  templateUrl: './earhiv-popup.component.html',
  styleUrl: './earhiv-popup.component.scss'
})
export class EarhivPopupComponent extends PrimeNGPopupViewComponent {
  override readonly DIALOG_WIDTH_TO_WINDOW_WIDTH_RATIO: number = 1;
}
